import { useLocation, useParams } from 'react-router-dom'

import { useProductReadContext } from '@context/ProductContext'

import { TickmillProductType } from '@model/TickmillProductType'

const tickmillProductTypes = Object.values(TickmillProductType).filter(
  (value): value is TickmillProductType => typeof value === 'number'
)

export const useResolvedAppTestProduct = (): TickmillProductType => {
  const { product } = useProductReadContext()
  const { productId } = useParams<{ productId?: string }>()
  const location = useLocation()
  const productIdFromPath = location.pathname.match(/\/product-registration\/(\d+)(?:\/|$)/)?.[1]
  const parsedProductId = Number(productId ?? productIdFromPath)

  return tickmillProductTypes.includes(parsedProductId as TickmillProductType)
    ? (parsedProductId as TickmillProductType)
    : product
}
